// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueImpression = (value) => ({
  type: actionTypes.SET_VALUE_Impression,
  payload: value,
});

export const setDateImpression = (date) => ({
  type: actionTypes.SET_DATE_Impression,
  payload: date,
});
export const setValidImpression = (valid) => ({
  type: actionTypes.SET_VALID_Impression,
  payload: valid,
});

export const setCurrentPageImpression = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_Impression,
  payload: page,
});

export const setOrderImpression = (order) => ({
  type: actionTypes.SET_ORDER_Impression,
  payload: order,
});

export const setSortFieldImpression = (field) => ({
  type: actionTypes.SET_SORT_FIELD_Impression,
  payload: field,
});
export const setCategorieImpression = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_Impression,
  payload: categorie,
});
